module.exports = __webpack_public_path__ + "img/svg/ps4-xboxone.66f8daad07c1a3d8b732249cbf3686c5.svg";